const RECEIPT_LABELS = {
  pickup_product: "إيصال الاستلام",
  delivery_proof: "إثبات التسليم",
};

const ReceiptsInfo = ({ receipts = [] }) => {
  if (!receipts || receipts.length === 0) return null;

  return (
    <div className="col-md-6 mt-3">
      <div className="card rounded-4 shadow-sm">
        <div className="card-body">
          <h5 className="text-smoke font16 font700">صور الإيصالات</h5>
          <div className="d-flex gap-3 flex-wrap mt-3">
            {receipts.map((receipt) =>
              receipt.is_image ? (
                <a
                  key={receipt.id}
                  href={receipt.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-center"
                  style={{ flex: "1 1 calc(50% - 0.5rem)" }}
                >
                  <img
                    src={receipt.url}
                    alt={RECEIPT_LABELS[receipt.receipt_type] || receipt.file_name}
                    className="rounded-3 border"
                    style={{ width: "100%", height: "auto", objectFit: "cover" }}
                  />
                  <div className="small text-muted mt-1">
                    {RECEIPT_LABELS[receipt.receipt_type] || receipt.receipt_type}
                  </div>
                </a>
              ) : null
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReceiptsInfo;